import moment from "moment";
import { axiosClient } from "../../config/axiosConfig"
import { message } from "antd";

export const Chat_TYPES = {
    SET_ISLOADING: 'SET_ISLOADING',
    GET_PERMITTEDAPPS: 'GET_PERMITTEDAPPS',
    SET_ENVIRONMENTID: 'SET_ENVIRONMENTID',
    GET_CONVERSATIONLIST: 'GET_CONVERSATIONLIST',
    GET_CHATHISTORY: 'GET_CHATHISTORY',
    SET_CONVERSATIONID: 'SET_CONVERSATIONID',
    CREATE_CONVERSATION: 'CREATE_CONVERSATION',
    DELETE_CONVERSATION: 'DELETE_CONVERSATION',
    UPDATE_TITLE: 'UPDATE_TITLE',
    UPDATE_PIN: 'UPDATE_PIN',
    UPDATE_CONVERSATIONID: 'UPDATE_CONVERSATIONID',
    SEND_MESSAGE: 'SEND_MESSAGE',
    ADD_CONVEERSATION_HISORY: 'ADD_CONVEERSATION_HISORY',
    SUBMIT_FEEDBACK: 'SUBMIT_FEEDBACK',
    UPDATE_THUMB:'UPDATE_THUMB',
    GET_USERPERMISSIONS:'GET_USERPERMISSIONS',
    GET_LIMITED_MESSAGES: 'GET_LIMITED_MESSAGES',
    POST_EVALUATION_SINGLE: 'POST_EVALUATION_SINGLE',
    GET_KPIS: 'GET_KPIS',
    GET_DASHBOARD_DATA: 'GET_DASHBOARD_DATA'
}

export const setIsLoading = (data) => async (dispatch) => {
    dispatch({
        type: Chat_TYPES.SET_ISLOADING,
        payload: data
    })
}

export const setEnvironmentId = (data) => async (dispatch) => {
    try {
        const response = await axiosClient.post('/api/chat/set_env/', data);

        dispatch({
            type: Chat_TYPES.SET_ENVIRONMENTID,
            payload: response
        })

    } catch (err) {

    }
}
export const getPermittedApps = (data) => async (dispatch) => {
    try {
        console.log("trying permitted apps");
        const response = await axiosClient.post('/api/chat/getpermittedapps/', data);
        console.log("permttedApps:",response);

        dispatch({
            type: Chat_TYPES.GET_PERMITTEDAPPS,
            payload: response
        })


    } catch (err) {
        console.log("permttedApps failed");

    }
}
export const getUserPermissions = (data) => async (dispatch) => {
    try {
        const response = await axiosClient.post('/api/chat/get_user_permissions/', data);


        dispatch({
            type: Chat_TYPES.GET_USERPERMISSIONS,
            payload: response
        })


    } catch (err) {
        dispatch({
            type: Chat_TYPES.GET_USERPERMISSIONS,
            //payload: ['error: unable to validate user permissions']
            payload: ["error - unable to validate user permissions"]
        })

    }
}
export const getConversationList = (data) => async (dispatch) => {
    try {
        const response = await axiosClient.post('/api/chat/getall/', {
            EnvID: data
        });

        dispatch({
            type: Chat_TYPES.GET_CONVERSATIONLIST,
            payload: response
        })

    } catch (err) {

    }
}

export const createConversation = (data) => async (dispatch) => {
    try {
        // dispatch({
        //     type: Chat_TYPES.CREATE_CONVERSATION,
        //     payload: { req: data, res: '' }
        // })

        // Get conversationID
        const conID = await axiosClient.post('/api/chat/create_convo/', {
            EnvID: data.envID,
            FirstMessage: data.user_prompt,
            Fields: {
                Subject: data.subject
            }
        })

        data.convoID = conID;

        dispatch({
            type: Chat_TYPES.CREATE_CONVERSATION,
            payload: { req: data, res: '' }
        })

        // Replace conversatoinID
        // await dispatch({
        //     type: Chat_TYPES.UPDATE_CONVERSATIONID,
        //     payload: { conID: conID, key: data.key }
        // })

        try {
            // Get Answer by passing Conversation, Question and UserID
            const response = await axiosClient.post('/api/chat/next_msg/', {
                EnvID: data.envID,
                ConvoID: conID,
                UserPrompt: data.user_prompt,
                IsNewTopic: true
            }
            );

            data.status = '';

            dispatch({
                type: Chat_TYPES.CREATE_CONVERSATION,
                payload: { req: data, res: response }
            })
        }
        catch (err) {
            data.status = 'E';
            const answer = {
                user_prompt: data.user_prompt,
                timestamp: data.timestamp,
                bot_response: '',
                bot_timestamp: moment(),
                status: 'E'
            }

            dispatch({
                type: Chat_TYPES.CREATE_CONVERSATION,
                payload: {
                    req: data,
                    res: answer
                }
            })
        }

    } catch (err) {

    }
}

export const sendMessage = (data) => async (dispatch) => {
    dispatch({
        type: Chat_TYPES.SEND_MESSAGE,
        payload: { req: data, res: '' }
    })

    try {
        const response = await axiosClient.post('/api/chat/next_msg/', {
            EnvID: data.envID,
            ConvoID: data.ConvoID,
            UserPrompt: data.user_prompt,
            IsNewTopic: data.isNewTopic
        }
        );

        data.status = '';

        dispatch({
            type: Chat_TYPES.SEND_MESSAGE,
            payload: { req: data, res: response }
        })
    } catch (err) {
        data.status = 'E';
        dispatch({
            type: Chat_TYPES.SEND_MESSAGE,
            payload: {
                req: data,
                res: ''
            }
        })
    }

    // try {
    //     if (data.chatHistoryLength === 2) {
    //         const title = await axiosClient.post('/api/chat/title/', {
    //             ConvoID: data.ConvoID,
    //             ConvoTitle: data.user_prompt
    //         }
    //         );

    //         var newTitle = {
    //             convoID: data.ConvoID,
    //             convoTitle: title,
    //             lastUpdated: moment()
    //         }
    //         dispatch({
    //             type: Chat_TYPES.UPDATE_TITLE,
    //             payload: newTitle
    //         })
    //     }
    // } catch (err) {

    // }
}

export const sendTumbStatus = (data) => async (dispatch) => {
    try {
        return await axiosClient.post('/api/chat/send_thumb/', data);
    } catch (err) {

    }
}

export const updateTumbStatus = (data) => async (dispatch) => {
    dispatch({
        type: Chat_TYPES.UPDATE_THUMB,
        payload: data
    })
}

export const deleteConversation = (data) => async (dispatch) => {
    try {
        await axiosClient.post('/api/chat/archive/', {
            ConvoID: data.ConvoID
        });

        dispatch({
            type: Chat_TYPES.DELETE_CONVERSATION,
            payload: data
        })

    } catch (err) {

    }
}

export const updateTitle = (data) => async (dispatch) => {
    try {
        await axiosClient.post('/api/chat/title/', {
            ConvoID: data.convoID,
            ConvoTitle: data.convoTitle
        });


        dispatch({
            type: Chat_TYPES.UPDATE_TITLE,
            payload: data
        })


    } catch (err) {

    }
}

export const getChatHistory = (data) => async (dispatch) => {
    try {
        const response = await axiosClient.post('/api/chat/getone/', {
            ConvoID: data.ConvoID
        });

        dispatch({
            type: Chat_TYPES.GET_CHATHISTORY,
            payload: {
                chatHistory: response.chat_history,
                fields: response.fields
            }
        })

    } catch (err) {
        dispatch({
            type: Chat_TYPES.SET_ISLOADING,
            payload: false
        })
    }
}

export const updatePin = (data) => async (dispatch) => {
    try {
        await axiosClient.post('/api/chat/set-conversation-pin/', {
            ConvoID: data.convoID,
            PinValue: data.pinValue
        });


        dispatch({
            type: Chat_TYPES.UPDATE_PIN,
            payload: data
        })


    } catch (err) {

    }
}

export const setConversationID = (data) => async (dispatch) => {
    try {
        dispatch({
            type: Chat_TYPES.SET_CONVERSATIONID,
            payload: data
        })

    } catch (err) {

    }
}

export const addConversationHistory = (data) => async (dispatch) => {
    try {
        dispatch({
            type: Chat_TYPES.ADD_CONVEERSATION_HISORY,
            payload: data
        })


    } catch (err) {

    }
}

export const submitFeedback = (data) => async (dispatch) => {
    await axiosClient.post('/api/chat/feedback/', data);
}

export const getLimitedMessages = (appData) => async (dispatch) => {
    try {
        const { AppName, table_limit_info, filters = [] } = appData; // Destructure filters from appData
        const { Start, Limit } = table_limit_info;
        const response = await axiosClient.post('/api/chat/getlimitedmessages/', {
            app_data: { AppName },
            table_limit_info: { Start, Limit },
            filters // Pass filters dynamically
        });

        const { MetaData, Messages } = response; // Extract MetaData and Messages

        dispatch({
            type: Chat_TYPES.GET_LIMITED_MESSAGES,
            payload: { MetaData, Messages } // Dispatch both MetaData and Messages
        });
        return Messages;
    } catch (err) {
        if (err.response) {
            console.warn("getLimitedMessages encountered a 500 error, suppressing error."); // Suppress specific error
        } else {
            console.error("Error fetching limited messages:", err); // Log other errors
        }
        return null; // Return null in case of an error
    }
};

export const postEvaluationsSingle = (data) => async (dispatch) => {
    try {
        const response = await axiosClient.post('/api/chat/postevaluationsone/', {
            app_data: data.app_data, // Use app_data from the passed data
            evaluation_message_data: data
        });

        dispatch({
            type: Chat_TYPES.POST_EVALUATION_SINGLE,
            payload: response
        });
    } catch (err) {
        console.error("Error posting evaluation:", err);
    }
};

export const getKpis = (data) => async (dispatch) => {
    try {
        const response = await axiosClient.post('/api/chat/getkpis/', {
            AppName: data.AppName
        });

        dispatch({
            type: Chat_TYPES.GET_KPIS,
            payload: response // Ensure the response is dispatched correctly
        });

        return response; // Return the response for further use
    } catch (err) {
        console.error("Error fetching KPIs:", err);
        return null; // Return null in case of an error
    }
};

export const getdashboarddata = (appData) => async (dispatch) => {
    try {
        const { AppName,filters = [] } = appData; 
        const response = await axiosClient.post('/api/chat/getdashboarddata/', {
            app_data: { AppName },
            filters // Pass filters dynamically
        });

        dispatch({
            type: Chat_TYPES.GET_DASHBOARD_DATA,
            payload: response // Ensure the response is dispatched correctly
        });

        return response; // Return the response for further use
    } catch (err) {
        console.error("Error fetching dashboarddata:", err);
        return null; // Return null in case of an error
    }
};

